import React from 'react';
import type { ExamSessionState } from '@interactive-room';

interface ExamDesarrolloReviewPanelProps {
  examSession: ExamSessionState | null | undefined;
  onConfirm: (participantId: string, blockId: string) => void;
}

export function ExamDesarrolloReviewPanel({ examSession, onConfirm }: ExamDesarrolloReviewPanelProps) {
  const pending = examSession?.pendingReviews?.filter((r) => r.pending) ?? [];
  if (pending.length === 0) return null;

  return (
    <div className="exam-review pointer-events-auto absolute bottom-4 left-4 z-20 w-80 max-h-56 overflow-y-auto rounded-xl border border-[var(--sala-border-strong)] bg-[var(--sala-surface-raised)] p-3 shadow-lg">
      <p className="sala-label mb-2">Revisión IA · Desarrollo</p>
      <ul className="space-y-2">
        {pending.map((review) => (
          <li key={`${review.participantId}-${review.blockId}`} className="rounded-lg border border-[var(--sala-border)] p-2 text-xs">
            <div className="flex items-center justify-between gap-2">
              <span className="font-semibold truncate">{review.displayName}</span>
              <span className="shrink-0 font-bold text-[var(--sala-accent)]">{review.score}/10</span>
            </div>
            <p className="mt-1 text-[10px] text-[var(--sala-ink-dim)] line-clamp-2">{review.text}</p>
            <p className="mt-1 text-[10px] italic text-[var(--sala-ink-muted)]">{review.feedback}</p>
            <button
              type="button"
              className="sala-btn-hero mt-2 w-full py-1 text-[9px]"
              onClick={() => onConfirm(review.participantId, review.blockId)}
            >
              Validar nota
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
